import React, { useState } from "react";
import moment from "moment";
import Alert from "../../../controls/Alert";

const PreBookValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  });

  let field = null;
  let error = false;
  let errorMessage = "";
  let id = null;

  if (!error && !record.newFlightDate) {
    error = true;
    errorMessage = "'New Flight Date' is required";
    id = "newFlightDate"
  }

  if (!error && !record.revisedExpectedAvailabilityAtOrigin) {
    error = true;
    errorMessage = "'Expected delivery at departure point' is required";
    id = "revisedExpectedAvailabilityAtOrigin"
  }

  if (!error && record.newFlightDate && record.revisedExpectedAvailabilityAtOrigin) {
    const flightDate = moment.utc(record.newFlightDate);
    const deliveryDate = moment.utc(record.revisedExpectedAvailabilityAtOrigin);
    if(deliveryDate.isAfter(flightDate)) {
      error = true;
      errorMessage = "'Delivery at departure point' must be prior to or on 'New Flight Date'";
      id = "revisedExpectedAvailabilityAtOrigin";
    }
  }

  if (!error && !record.departureFlight) {
    error = true;
    errorMessage = "Search and select a new departure flight";
    id = "search";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage} id={id}/>
  );

}

export default PreBookValidator;
